import { render, staticRenderFns } from "./ShopStoreData.vue?vue&type=template&id=f037fa30&"
import script from "./ShopStoreData.vue?vue&type=script&lang=js&"
export * from "./ShopStoreData.vue?vue&type=script&lang=js&"
import style0 from "./ShopStoreData.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports